var _rect, _path, _path2, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7606 10.9852C12.7606 12.0494 11.9503 12.9106 10.6832 12.9106C9.46545 12.9106 8.65518 12.0494 8.68025 10.9852C8.65518 9.86933 9.46543 9.0332 10.7075 9.0332C11.9503 9.0332 12.7363 9.86933 12.7606 10.9852ZM8.78213 26.8269V14.4316H12.6344V26.8262H8.78213V26.8269Z",
    fill: "#28475C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5609 18.5273C15.5609 16.9812 15.5099 15.6631 15.459 14.5731H18.8051L18.9829 16.2712H19.059C19.566 15.4852 20.8331 14.2949 22.8862 14.2949C25.4205 14.2949 27.3216 15.968 27.3216 19.6165V26.9685H23.4692V20.0992C23.4692 18.5014 22.9121 17.4122 21.518 17.4122C20.453 17.4122 19.8199 18.1472 19.5668 18.8564C19.4649 19.1103 19.4147 19.4645 19.4147 19.8202V26.9685H15.5624V18.5273H15.5609Z",
    fill: "#28475C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#EBF0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.b5befa140d0951fdd4b3e921afc6cce1.svg";
export { ForwardRef as ReactComponent };